import React from "react";
import { Building2, ChevronDown } from "lucide-react";

const Organogram = () => {
    const orgData = {
        registrar: "Registrar of Cooperative Societies",
        ar: [
            {
                code: "AR (CA)",
                name: "Consumer Cooperatives & PDS",
                jr: [
                    {
                        code: "JR (CC)",
                        name: "Consumer Cooperatives",
                        dr: ["DR (PDS)", "DR (CC)", "DR (C&B)"]
                    }
                ]
            },
            {
                code: "AR (F&B)",
                name: "Credit Cooperatives",
                jr: [
                    {
                        code: "JR (F&B)",
                        name: "Loans & Banks",
                        dr: ["PA to RCS", "FA & CAO", "DR (PMC)", "DR (IC)", "DR (G)", "DR (F)"]
                    }
                ]
            },
            {
                code: "AR (MPD)",
                name: "Statutory & Marketing",
                jr: [
                    {
                        code: "JR (S&T)",
                        name: "Statutory Functions",
                        dr: ["DR (S)"]
                    },
                    {
                        code: "JR (LEGAL)",
                        name: "Legal Cell",
                        dr: []
                    }
                ]
            },
            {
                code: "AR (ICDP)",
                name: "Development Projects",
                jr: [
                    {
                        code: "JR (CC)",
                        name: "Planning",
                        dr: ["AD (S)", "FA & CAO", "DR (RC)"]
                    }
                ]
            },
            {
                code: "AR (Election)",
                name: "Elections",
                jr: [
                    {
                        code: "JR (S&T)",
                        name: "Election Management",
                        dr: ["DR (RC)", "DR (S)", "DR (Election)"]
                    }
                ]
            }
        ]
    };

    return (
        <div className="pt-6 pb-12">
            <div className="max-w-[98%] mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-4">
                    <div className="inline-flex items-center justify-center gap-3 mb-4">
                        <Building2 className="w-10 h-10 text-[#005A8D]" />
                        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800">
                            Organizational Structure
                        </h2>
                    </div>
                    <div className="w-28 h-1.5 bg-[#005A8D] mx-auto mb-3"></div>
                    <p className="text-gray-600 text-base font-medium">Hierarchical Structure of the Department</p>
                </div>

                <div className="bg-white shadow-2xl border-t-4 border-[#005A8D] overflow-hidden">
                    <div className="p-10 md:p-14 bg-gray-50">

                        {/* Registrar */}
                        <div className="flex flex-col items-center mb-12">
                            <div className="bg-[#005A8D] text-white px-12 py-5 rounded-lg shadow-xl border-2 border-[#004a73] transform hover:scale-105 transition-transform duration-300">
                                <p className="font-bold text-2xl text-center">{orgData.registrar}</p>
                            </div>
                            <div className="flex flex-col items-center my-5">
                                <div className="w-1 h-14 bg-[#005A8D]"></div>
                                <ChevronDown className="w-7 h-7 text-[#005A8D]" />
                            </div>
                        </div>

                        {/* AR Level */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 mb-10">
                            {orgData.ar.map((ar, idx) => (
                                <div key={idx} className="flex flex-col items-center">
                                    <div className="w-full bg-[#0077B6] rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-[#004a73]">
                                        <div className="p-5">
                                            <div className="bg-white/20 backdrop-blur-sm rounded px-4 py-2 mb-2">
                                                <p className="font-bold text-base text-center text-white">{ar.code}</p>
                                            </div>
                                            <p className="text-sm text-center leading-tight text-white min-h-[36px] flex items-center justify-center">
                                                {ar.name}
                                            </p>
                                        </div>
                                    </div>

                                    {ar.jr.length > 0 && (
                                        <div className="flex flex-col items-center my-4">
                                            <div className="w-1 h-8 bg-[#005A8D]"></div>
                                            <div className="w-3 h-3 rounded-full bg-[#005A8D]"></div>
                                        </div>
                                    )}

                                    {ar.jr.length > 0 && (
                                        // MODIFIED: Removed 'flex-wrap' to force JR boxes onto one line
                                        <div className="w-full flex flex-row gap-4 justify-center items-start">
                                            {ar.jr.map((jr, jrIdx) => (
                                                <div key={jrIdx} className="flex flex-col items-center">
                                                    <div className="bg-[#B3E5FC] rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-[#81D4FA] min-w-[140px]">
                                                        <div className="p-4">
                                                            <div className="bg-white/25 backdrop-blur-sm rounded px-3 py-1 mb-2">
                                                                <p className="font-semibold text-sm text-center text-gray-800">{jr.code}</p>
                                                            </div>
                                                            <p className="text-xs text-center leading-tight text-gray-800 min-h-[30px] flex items-center justify-center">
                                                                {jr.name}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {jr.dr.length > 0 && (
                                                        <>
                                                            <div className="flex flex-col items-center my-3">
                                                                <div className="w-0.5 h-7 bg-[#00B4D8]"></div>
                                                                <div className="w-2 h-2 rounded-full bg-[#81D4FA]"></div>
                                                            </div>

                                                            <div className="w-full flex flex-wrap gap-3 justify-center">
                                                                {jr.dr.map((dr, drIdx) => (
                                                                    <div
                                                                        key={drIdx}
                                                                        className="bg-[#E1F5FE] px-4 py-2 rounded shadow hover:shadow-md transition-all duration-200 border border-[#00B4D8]/30 hover:border-[#00B4D8] transform hover:-translate-y-0.5"
                                                                    >
                                                                        <p className="font-medium text-xs text-center whitespace-nowrap text-gray-800">
                                                                            {dr}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="mt-6 text-center">
                            <p className="text-sm text-gray-500 italic">
                                * Organizational structure as per current administrative setup
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Organogram;